import React from 'react'
import { Row, Col } from 'reactstrap'
import { connect } from "react-redux"
import Profile from './Profile'
import Breadcrumbs from './Breadcrumbs'

const Header = ({ toggleMenuCallback, isSmallScreen, Auth }) => {
    return(
        <header>
            <div className='navbar-profile'>
                <Row>
                    <Col xs={8} sm={10} md={9} lg={9} xl={10}>
                        <Row>
                            {isSmallScreen && (
                                <Col xs={1} sm={2} md={2} lg={1}>
                                    <button
                                        onClick={(e) => {
                                            e.preventDefault()
                                            toggleMenuCallback()
                                        }}
                                        className="font-size-24 waves-effect"
                                        id="vertical-menu-btn"
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer',
                                            padding: '0'
                                        }}
                                    >
                                        <i className="fa fa-fw fa-bars"></i>
                                    </button>
                                </Col>
                            )}

                            <Col xs={10} sm={10} md={10} lg={12}>
                                <Breadcrumbs />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={4} sm={2} md={2} lg={2} xl={2}>
                        <div className="navbar-profile-actions">
                            <Profile profile={Auth.profile} />
                        </div>
                    </Col>
                </Row>
            </div>
        </header>
    )
}

const mapStatetoProps = (state) => {
    const { Auth } = state
    return { Auth }
}

export default connect(mapStatetoProps)(Header)